export const APP_NAME = "Smash Education"
export const API_BASE_URL = "https://smasheducation.com/services/api/"
export const UNAUTHENTICATED_ENTRY = "/login"
export const AUTHENTICATED_ENTRY = "/missions"
export const PROFESSOR_AUTHENTICATED_ENTRY = "/professor/missions"
